var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.212,
    height: 48.77,
    viewBox: "0 0 48.212 48.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Registration",
    transform: "translate(-1151.711 -184.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4293",
    "data-name": "Rectangle 4293",
    width: 20,
    height: 7,
    rx: 2,
    transform: "translate(1157 190)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M-11462.552,2194.86l3.423,3.539,15.258-15.49-3.423-3.133Z",
    transform: "translate(12641 -1973)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2789",
    "data-name": "Ellipse 2789",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1157 201)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2790",
    "data-name": "Ellipse 2790",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1157 209)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2791",
    "data-name": "Ellipse 2791",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1157 216)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M47.5,19.813a3.048,3.048,0,0,0-4.315,0l-1.524,1.524h0l-4.9,4.9V11.43a.735.735,0,0,0-.02-.1.7.7,0,0,0-.018-.094.75.75,0,0,0-.184-.346L25.868.224a.75.75,0,0,0-.344-.186A.689.689,0,0,0,25.431.02a.738.738,0,0,0-.1-.02H3.993A3.81,3.81,0,0,0,.183,3.81V44.96a3.81,3.81,0,0,0,3.81,3.81H32.95a3.81,3.81,0,0,0,3.81-3.81v-10.1l9.214-9.214h0L47.5,24.126a3.048,3.048,0,0,0,0-4.313ZM26.092,2.6l8.067,8.067H28.378a2.286,2.286,0,0,1-2.286-2.286Zm-.736,8.067H7.041a.762.762,0,0,1-.762-.762V6.858A.762.762,0,0,1,7.041,6.1H24.568V8.382a3.774,3.774,0,0,0,.788,2.286ZM35.243,44.96a2.286,2.286,0,0,1-2.286,2.286H4A2.286,2.286,0,0,1,1.713,44.96V3.81a2.286,2.286,0,0,1,2.28-2.286H24.568V4.572H7.041A2.286,2.286,0,0,0,4.755,6.858V9.906a2.286,2.286,0,0,0,2.286,2.286h28.2V27.767l-8.75,8.75a.724.724,0,0,0-.088.134c-.015.024-.041.038-.053.064l-2.155,4.31a.75.75,0,0,0,.1.8l-.948.957a.762.762,0,1,0,1.084,1.067l.922-.933.058.058a.762.762,0,0,0,.879.143l4.31-2.157c.026-.012.04-.038.064-.053a.724.724,0,0,0,.134-.088l4.44-4.438Zm-8-6.617,1.737,1.737-2.873,1.437L25.9,41.31V41.3h-.009l-.079-.079Zm8.23-4.334h0l-5.2,5.2L28.1,37.056l14.1-14.1,2.155,2.155ZM46.434,23.045l-.988.988L43.29,21.876l.988-.988a1.525,1.525,0,1,1,2.157,2.157Zm-33.3,1.34H31.426a.762.762,0,1,0,0-1.524H13.138a.762.762,0,0,0,0,1.524Zm0-4.572H31.426a.762.762,0,0,0,0-1.524H13.138a.762.762,0,0,0,0,1.524Zm7.62,22.747a2.713,2.713,0,0,1-1.641-.5,4.455,4.455,0,0,0-4.851,0,2.713,2.713,0,0,1-1.641.5,2.71,2.71,0,0,1-1.637-.5,4.194,4.194,0,0,0-2.422-.719.762.762,0,1,0,0,1.524,2.71,2.71,0,0,1,1.638.5,4.194,4.194,0,0,0,2.422.719,4.208,4.208,0,0,0,2.425-.718,2.935,2.935,0,0,1,3.281,0,4.208,4.208,0,0,0,2.425.718.762.762,0,0,0,0-1.524Zm-7.62-25.795H31.426a.762.762,0,0,0,0-1.524H13.138a.762.762,0,0,0,0,1.524Zm0,10.668H31.426a.762.762,0,0,0,0-1.524H13.138a.762.762,0,0,0,0,1.524Zm-6.1,0a2.286,2.286,0,1,0-2.286-2.286,2.286,2.286,0,0,0,2.286,2.286Zm0-3.048a.762.762,0,1,1-.762.762.762.762,0,0,1,.762-.762Zm2.286,8.382a2.286,2.286,0,1,0-2.286,2.286,2.286,2.286,0,0,0,2.286-2.286Zm-2.286.762a.762.762,0,1,1,.762-.762.762.762,0,0,1-.762.762Zm6.1-1.524H25.33a.762.762,0,0,0,0-1.524H13.138a.762.762,0,0,0,0,1.524Zm-6.1-12.193a2.286,2.286,0,1,0-2.286-2.286,2.286,2.286,0,0,0,2.286,2.286Zm0-3.048a.762.762,0,1,1-.762.762.762.762,0,0,1,.762-.762Zm6.1,18.289H25.33a.762.762,0,1,0,0-1.524H13.138a.762.762,0,1,0,0,1.524Z",
    transform: "translate(1151.528 184.966)",
    fill: "#3d4977"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistration);
export default __webpack_public_path__ + "static/media/Registration.620b5f37fde875fcff2817ef4247854e.svg";
export { ForwardRef as ReactComponent };